import { DeviceInfo } from '../types';

const get_device_metadata = () => {
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";

  // --- Device Class ---
  let deviceClass: DeviceInfo["deviceClass"] = "desktop";
  if (/Tablet|iPad/i.test(ua)) deviceClass = "tablet";
  else if (/Mobi|Android/i.test(ua)) deviceClass = "mobile";

  // --- OS ---
  let os = "Unknown";
  if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Macintosh|Mac OS X/i.test(ua)) os = "macOS";
  else if (/Win/i.test(ua)) os = "Windows";
  else if (/Linux/i.test(platform)) os = "Linux";

  // --- OS Version ---
  let osVersion: string | null = null;

  if (os === "iOS") {
    // iOS (example: "OS 15_2")
    const match = ua.match(/OS (\d+[_\d]*)/);
    osVersion = match ? match[1].replace(/_/g, ".") : null;
  }

  if (os === "Android") {
    // Android (example: "Android 12")
    const match = ua.match(/Android (\d+(\.\d+)?)/);
    osVersion = match ? match[1] : null;
  }

  if (os === "macOS") {
    // macOS (example: "Mac OS X 10_15_7")
    const match = ua.match(/Mac OS X (\d+[_\d]*)/);
    osVersion = match ? match[1].replace(/_/g, ".") : null;
  }

  if (os === "Windows") {
    // Windows (example: "Windows NT 10.0")
    const match = ua.match(/Windows NT (\d+(\.\d+)?)/);
    osVersion = match ? match[1] : null;
  }

  // --- Browser ---
  let browser = "Unknown";
  if (ua.includes("Edg")) browser = "Edge";
  else if (ua.includes("Firefox")) browser = "Firefox";
  else if (ua.includes("Chrome") && !ua.includes("Edg") && !ua.includes("Chromium")) browser = "Chrome";
  else if (ua.includes("Safari") && !ua.includes("Chrome")) browser = "Safari";

  // --- Browser Version ---
  let browserVersion: string | null = null;

  const browserVersionRegexes: { [key: string]: RegExp } = {
    Chrome: /Chrome\/([\d.]+)/,
    Safari: /Version\/([\d.]+)/,
    Firefox: /Firefox\/([\d.]+)/,
    Edge: /Edg\/([\d.]+)/,
  };

  if (browserVersionRegexes[browser]) {
    const match = ua.match(browserVersionRegexes[browser]);
    browserVersion = match ? match[1] : null;
  }

  return {
    deviceClass,
    os,
    osVersion,
    browser,
    browserVersion,
  };
}

export default get_device_metadata;